import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router';
import moment from 'moment';

import VueResource from 'vue-resource';
import AsyncComputedPlugin from 'vue-async-computed'

import { abilitiesPlugin, Can } from '@casl/vue';
import { buildAbilityFor } from '@/services/abilities-service';

import VueCurrencyFilter from 'vue-currency-filter';

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue';
//import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(VueResource);
Vue.use(AsyncComputedPlugin);

const ability = buildAbilityFor(null);
Vue.use(abilitiesPlugin, ability)
Vue.component('Can', Can)

// router.beforeEach((to, from, next) => {
//   const canNavigate = to.matched.some(route => {
//     return ability.can('visit', route.meta.resource)
//   })

//   if (!canNavigate) {
//     return next('/')
//   }

//   next()
// })

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

moment.locale('it');

Vue.config.productionTip = false;

Vue.filter('formatDateTime', (value: string) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY H:mm');
  } else {
    return value;
  }
});

Vue.filter('percentageVariant', (value: number) => {
  if (value < 10) {
    return "danger";
  } else if (value > 90) {
    return "success";
  } else {
    return "warning";
  }
});

Vue.filter('truncate', (text: string, stop: number, clamp: string) => {
  return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
});

Vue.use(VueCurrencyFilter,
  {
    symbol: '€',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  });

Vue.filter('slashedDate', (dashedDate: string) => {
  const splitted = dashedDate.split("-", 3);
  return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
});

Vue.filter('capitalize', (value: unknown) => {
  if (!value) {
    return "";
  }
  const newVal = String(value);
  return newVal.charAt(0).toUpperCase() + newVal.slice(1);
});

Vue.filter('round', (value: number, decimals: number) => {
  if (!value) {
    value = 0;
  }
  if (!decimals) {
    decimals = 0;
  }

  return Math.round(value * Math.pow(10, decimals))/Math.pow(10, decimals);
});

Vue.filter('localeNumber', (value: number) => {
  if (!value) {
    return "";
  }
  return value.toLocaleString();
})

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
